import { useEffect, useState } from "react";
import styled from "styled-components";
import { Theme } from "../../themes/theme";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Number = styled.p`
  font-family: ${Theme.font.fontFamily.heading};
  font-size: ${Theme.font.fontSize.xxxl};
  font-weight: ${Theme.font.fontWeight.bold};
  color: ${Theme.color.text.heading};
  line-height: 1;
  margin: 0;
  span {
    margin-left: 2px;
    color: ${Theme.color.text.primary};
  }
`;

const Label = styled.span`
  font-size: ${Theme.font.fontSize.sm};
  color: ${Theme.color.text.secondary};
  text-transform: uppercase;
  letter-spacing: ${Theme.font.letterSpacing.wide};
`;
const Description = styled.p`
  font-size: ${Theme.font.fontSize.sm};
  color: ${Theme.color.text.heading};
  line-height: ${Theme.font.lineHeight.snug};
  margin: 0;
`;
function CountUpStat({
  value = 100,
  duration = 2000,
  label,
  suffix = "",
  description,
}) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = value / (duration / 16);

    const timer = setInterval(() => {
      start += increment;

      if (start >= value) {
        setCount(value);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [value, duration]);

  return (
    <Wrapper>
      <Number>
        {count}
        <span>{suffix}</span>
      </Number>

      <Label>{label}</Label>
      <Description>{description}</Description>
    </Wrapper>
  );
}

export default CountUpStat;
